module.exports = __webpack_public_path__ + "img/Weapon_43.449d4a15.png";